var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "import-old-note__wrapper",
      attrs: {
        visible: _vm.isVisible,
        size: "medium",
        title: _vm.$t.__(
          "popups.overviews.ImportOldOppOverviewNote.merge_informations"
        ),
        "body-scroll": "",
        "close-on-click-overlay": false
      },
      on: {
        "update:visible": function($event) {
          _vm.isVisible = $event
        },
        closed: _vm.close
      }
    },
    [
      _c(
        "div",
        { attrs: { slot: "default" }, slot: "default" },
        [
          _c("CompassAlert", {
            attrs: {
              type: "informative",
              "show-close": false,
              description: _vm.alertInfoContent
            }
          }),
          _vm._v(" "),
          _c("div", [
            _c("p", { staticClass: "bold fs-3 lh-20 mt-0 mb-2" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$l10n.__("Ancienne donnée de la note")) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "fs-3 lh-20 m-0",
              domProps: { innerHTML: _vm._s(_vm.oldNoteValue) }
            })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex-row pb-5 px-5 pt-4 import-old-note__footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.cancel"),
              type: "secondary"
            },
            on: { click: _vm.close }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            staticClass: "ml-3",
            attrs: {
              label: _vm.$t.__(
                "popups.overviews.ImportOldOppOverviewNote.import_in_comment"
              ),
              "left-icon": "download"
            },
            on: { click: _vm.importOldNote }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }